// extracted by mini-css-extract-plugin
export default {"textBoxWrapper":"textBoxWrapper--SKHjQ","error":"error--Uc3Mm","textArea":"textArea--l0sy0","hidePlaceholderOnFocus":"hidePlaceholderOnFocus--k2xA4","disabled":"disabled--JFr_l"};